import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useState, useEffect, useRef } from 'react';
import { addDays } from 'date-fns';
import './p1Date.css'
const P1Date = ({dateRange, handleSetDateRange, months}) => {
    return (
        <DateRangePicker
          onChange={(item) => handleSetDateRange([item.selection])}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          ranges={dateRange}
          months={months}
          preventSnapRefocus={true}	
          rangeColors={['#0FBAB5']}
          textColors={['#000']}
          direction="horizontal"
        />
    );
};

export default P1Date;